const customDataColumnNames = Array(40)
	.fill(0)
	.map((_0, i) => `custom_data${i + 1}`);

const customDataColumnsMixin = customDataColumnNames.reduce(
	(res, colName) => ({ ...res, [colName]: colName }),
	{}
);

export const COLUMNS = {
	SPEND_TYPE: 'SPEND_TYPE',
	PURCHASING_LOCATION_ID: 'PURCHASING_LOCATION_ID',
	ID: 'ID',
	PO_ID: 'PO_ID',
	PO_ID_AP: 'PO_ID_AP',
	PO_TYPE: 'PO_TYPE',
	PARENT_LEGAL_ENTITY: 'PARENT_LEGAL_ENTITY',
	ACCOUNT_GROUP: 'ACCOUNT_GROUP',
	RAW_MATERIAL_SOURCING_REGION: 'RAW_MATERIAL_SOURCING_REGION',
	VENDOR_ID: 'VENDOR_ID',
	VENDOR_NAME: 'VENDOR_NAME',
	VENDOR_COUNTRY: 'VENDOR_COUNTRY',
	VENDOR_ADDRESS: 'VENDOR_ADDRESS',
	VENDOR_ADDRESS_CITY: 'VENDOR_ADDRESS_CITY',
	AP_GEO_VENDOR_REGION: 'AP_GEO_VENDOR_REGION',
	AP_GEO_VENDOR_COUNTRY: 'AP_GEO_VENDOR_COUNTRY',
	AP_GEO_VENDOR_COST_GROUP: 'AP_GEO_VENDOR_COST_GROUP',
	HARMONIZED_VENDOR_ID: 'HARMONIZED_VENDOR_ID',
	HARMONIZED_VENDOR_NAME: 'HARMONIZED_VENDOR_NAME',
	PURCHASING_LEGAL_ENTITY: 'PURCHASING_LEGAL_ENTITY',
	PURCHASING_LOCATION: 'PURCHASING_LOCATION',
	PURCHASING_LOCATION_COUNTRY: 'PURCHASING_LOCATION_COUNTRY',
	PURCHASING_LOCATION_STATE: 'PURCHASING_LOCATION_STATE',
	RECEIVING_LOCATION: 'RECEIVING_LOCATION',
	RECEIVING_LOCATION_COUNTRY: 'RECEIVING_LOCATION_COUNTRY',
	RECEIVING_LOCATION_STATE: 'RECEIVING_LOCATION_STATE',
	PURCHASING_DEPARTMENT: 'PURCHASING_DEPARTMENT',
	PURCHASING_GROUP: 'PURCHASING_GROUP',
	PURCHASING_COUNTRY: 'PURCHASING_COUNTRY',
	PURCHASING_ADDRESS: 'PURCHASING_ADDRESS',
	PURCHASING_ADDRESS_CITY: 'PURCHASING_ADDRESS_CITY',
	AP_GEO_PURCHASING_ENTITY_REGION: 'AP_GEO_PURCHASING_ENTITY_REGION',
	AP_GEO_PURCHASING_ENTITY_COUNTRY: 'AP_GEO_PURCHASING_ENTITY_COUNTRY',
	AP_GEO_PURCHASING_ENTITY_COST_GROUP: 'AP_GEO_PURCHASING_ENTITY_COST_GROUP',
	RECEIVING_LEGAL_ENTITY: 'RECEIVING_LEGAL_ENTITY',
	RECEIVING_DEPARTMENT: 'RECEIVING_DEPARTMENT',
	RECEIVING_GROUP: 'RECEIVING_GROUP',
	RECEIVING_COUNTRY: 'RECEIVING_COUNTRY',
	RECEIVING_ADDRESS: 'RECEIVING_ADDRESS',
	RECEIVING_ADDRESS_CITY: 'RECEIVING_ADDRESS_CITY',
	AP_GEO_RECEIVING_ENTITY_REGION: 'AP_GEO_RECEIVING_ENTITY_REGION',
	AP_GEO_RECEIVING_ENTITY_COUNTRY: 'AP_GEO_RECEIVING_ENTITY_COUNTRY',
	AP_GEO_RECEIVING_ENTITY_COST_GROUP: 'AP_GEO_RECEIVING_ENTITY_COST_GROUP',
	PO_BASE_CURRENCY: 'PO_BASE_CURRENCY',
	PO_BASE_SPEND: 'PO_BASE_SPEND',
	PO_LINE_ITEM_DESCRIPTION: 'PO_LINE_ITEM_DESCRIPTION',
	PO_GL_CODE: 'PO_GL_CODE',
	PO_COST_CENTRE: 'PO_COST_CENTRE',
	PO_CREATION_DATE: 'PO_CREATION_DATE',
	NET_VALUE_BASE_GBP: 'NET_VALUE_BASE_GBP',
	NET_VALUE_BASE_EUR: 'NET_VALUE_BASE_EUR',
	NET_VALUE_BASE_USD: 'NET_VALUE_BASE_USD',
	SOURCEABLE: 'SOURCEABLE',
	AP_L1Category: 'AP_L1Category',
	AP_L1Code: 'AP_L1Code',
	AP_L2Category: 'AP_L2Category',
	AP_L2Code: 'AP_L2Code',
	AP_L3Category: 'AP_L3Category',
	AP_L3Code: 'AP_L3Code',
	AP_L4Category: 'AP_L4Category',
	AP_L4Code: 'AP_L4Code',
	Custom_L1Category: 'Custom_L1Category',
	Custom_L1Code: 'Custom_L1Code',
	Custom_L2Category: 'Custom_L2Category',
	Custom_L2Code: 'Custom_L2Code',
	Custom_L3Category: 'Custom_L3Category',
	Custom_L3Code: 'Custom_L3Code',
	Custom_L4Category: 'Custom_L4Category',
	Custom_L4Code: 'Custom_L4Code',
	Custom_L5Category: 'Custom_L5Category',
	Custom_L5Code: 'Custom_L5Code',
	CLASSIFIED_BY: 'CLASSIFIED_BY',
	PREDICTION_CONFIDENCE: 'PREDICTION_CONFIDENCE',
	website: 'website',
	IsTailSpend: 'IsTailSpend',
	DPO: 'DPO',

	...customDataColumnsMixin,
};

export const COLUMN_STATE_DEFAULTS = {
	width: 200,
	pivotIndex: null,
	pinned: null,
	rowGroupIndex: null,
};

export const SOURCEABLE_COLUMN = {
	colId: 'SOURCEABLE',
};

export const DEFAULT_CLICKTHROUGH_COLUMNS = [
	{
		colId: 'VENDOR_ID',
	},
	{
		colId: 'VENDOR_NAME',
	},
];

export const DEFAULT_CATEGORIES_LIST = [
	{
		colId: 'AP_L1Category',
		hide: false,
	},
	{
		colId: 'AP_L2Category',
		hide: false,
	},
	{
		colId: 'AP_L3Category',
		hide: false,
	},
	{
		colId: 'AP_L4Category',
		hide: false,
	},
];

export const DEFAULT_CUSTOM_CATEGORIES_LIST = [
	{
		colId: 'Custom_L1Category',
		hide: false,
	},
	{
		colId: 'Custom_L2Category',
		hide: false,
	},
	{
		colId: 'Custom_L3Category',
		hide: false,
	},
	{
		colId: 'Custom_L4Category',
		hide: false,
	},
];

const customDataDefalutColumnsState = customDataColumnNames.map(colId => ({
	colId,
	hide: false,
}));

export const DEFAULT_COLUMN_STATE = [
	{
		colId: 'SPEND_TYPE',
		hide: false,
	},

	{
		colId: 'ID',
		hide: false,
		width: 100,
	},
	{
		colId: 'VENDOR_NAME',
		hide: false,
	},
	{
		colId: 'HARMONIZED_VENDOR_NAME',
		hide: false,
		width: 287,
	},
	{
		colId: 'SOURCEABLE',
		hide: false,
		width: 141,
	},
	{
		colId: 'HARMONIZED_VENDOR_ID',
		hide: true,
	},
	{
		colId: 'NET_VALUE_BASE_GBP',
		hide: true,
		width: 197,
	},
	{
		colId: 'NET_VALUE_BASE_USD',
		hide: true,
	},
	{
		colId: 'NET_VALUE_BASE_EUR',
		hide: true,
	},
	{
		colId: 'PO_BASE_SPEND',
		hide: false,
	},
	{
		colId: 'PO_BASE_CURRENCY',
		hide: false,
	},
	{
		colId: 'PO_GL_CODE',
		hide: true,
	},
	{
		colId: 'PO_COST_CENTRE',
		hide: true,
	},
	{
		colId: 'PO_CREATION_DATE',
		hide: true,
	},
	{
		colId: 'PO_LINE_ITEM_DESCRIPTION',
		hide: true,
	},
	{
		colId: 'PO_ID',
		hide: true,
	},
	{
		colId: 'PO_ID_AP',
		hide: true,
	},
	{
		colId: 'PO_TYPE',
		hide: true,
	},
	{
		colId: 'PARENT_LEGAL_ENTITY',
		hide: true,
	},
	{
		colId: 'ACCOUNT_GROUP',
		hide: true,
	},
	{
		colId: 'RAW_MATERIAL_SOURCING_REGION',
		hide: true,
	},
	{
		colId: 'VENDOR_ID',
		hide: true,
	},
	{
		colId: 'VENDOR_COUNTRY',
		hide: true,
	},
	{
		colId: 'VENDOR_ADDRESS',
		hide: true,
	},
	{
		colId: 'VENDOR_ADDRESS_CITY',
		hide: true,
	},
	{
		colId: 'AP_GEO_VENDOR_REGION',
		hide: true,
	},
	{
		colId: 'AP_GEO_VENDOR_COUNTRY',
		hide: true,
	},
	{
		colId: 'AP_GEO_VENDOR_COST_GROUP',
		hide: true,
	},
	{
		colId: 'PURCHASING_LEGAL_ENTITY',
		hide: true,
	},
	{
		colId: 'PURCHASING_LOCATION',
		hide: true,
	},
	{
		colId: 'RECEIVING_LOCATION',
		hide: true,
	},
	{
		colId: 'PURCHASING_LOCATION_COUNTRY',
		hide: true,
	},
	{
		colId: 'PURCHASING_LOCATION_ID ',
		hide: true,
	},
	{
		colId: 'PURCHASING_LOCATION_STATE',
		hide: true,
	},
	{
		colId: 'RECEIVING_LOCATION_COUNTRY',
		hide: true,
	},
	{
		colId: 'RECEIVING_LOCATION_STATE',
		hide: true,
	},
	{
		colId: 'PURCHASING_DEPARTMENT',
		hide: true,
	},
	{
		colId: 'PURCHASING_GROUP',
		hide: true,
	},
	{
		colId: 'PURCHASING_COUNTRY',
		hide: true,
	},
	{
		colId: 'PURCHASING_ADDRESS',
		hide: true,
	},
	{
		colId: 'PURCHASING_ADDRESS_CITY',
		hide: true,
	},
	{
		colId: 'AP_GEO_PURCHASING_ENTITY_REGION',
		hide: true,
	},
	{
		colId: 'AP_GEO_PURCHASING_ENTITY_COUNTRY',
		hide: true,
	},
	{
		colId: 'AP_GEO_PURCHASING_ENTITY_COST_GROUP',
		hide: true,
	},
	{
		colId: 'RECEIVING_LEGAL_ENTITY',
		hide: true,
	},
	{
		colId: 'RECEIVING_DEPARTMENT',
		hide: true,
	},
	{
		colId: 'RECEIVING_GROUP',
		hide: true,
	},
	{
		colId: 'RECEIVING_COUNTRY',
		hide: true,
	},
	{
		colId: 'RECEIVING_ADDRESS',
		hide: true,
	},
	{
		colId: 'RECEIVING_ADDRESS_CITY',
		hide: true,
	},
	{
		colId: 'AP_GEO_RECEIVING_ENTITY_REGION',
		hide: true,
	},
	{
		colId: 'AP_GEO_RECEIVING_ENTITY_COUNTRY',
		hide: true,
	},
	{
		colId: 'AP_GEO_RECEIVING_ENTITY_COST_GROUP',
		hide: true,
	},
	{
		colId: 'AP_L1Category',
		hide: false,
	},
	{
		colId: 'AP_L1Code',
		hide: true,
	},
	{
		colId: 'AP_L2Category',
		hide: false,
	},
	{
		colId: 'AP_L2Code',
		hide: true,
	},
	{
		colId: 'AP_L3Category',
		hide: false,
	},
	{
		colId: 'AP_L3Code',
		hide: true,
	},
	{
		colId: 'AP_L4Category',
		hide: false,
	},
	{
		colId: 'AP_L4Code',
		hide: true,
	},
	{
		colId: 'AP_L5Category',
		hide: false,
	},
	{
		colId: 'Custom_L1Category',
		hide: false,
	},
	{
		colId: 'Custom_L1Code',
		hide: true,
	},
	{
		colId: 'Custom_L2Category',
		hide: false,
	},
	{
		colId: 'Custom_L2Code',
		hide: true,
	},
	{
		colId: 'Custom_L3Category',
		hide: false,
	},
	{
		colId: 'Custom_L3Code',
		hide: true,
	},
	{
		colId: 'Custom_L4Category',
		hide: false,
	},
	{
		colId: 'Custom_L4Code',
		hide: true,
	},
	{
		colId: 'Custom_L5Category',
		hide: false,
	},
	{
		colId: 'Custom_L5Code',
		hide: true,
	},
	{
		colId: 'CLASSIFIED_BY',
		hide: true,
	},
	{
		colId: 'PREDICTION_CONFIDENCE',
		hide: true,
	},
	{
		colId: 'website',
		hide: true,
	},
	{
		colId: 'IsTailSpend',
		hide: false,
	},

	...customDataDefalutColumnsState,
];

export const COLUMN_DEFS = [
	{
		headerName: 'ID',
		field: 'ID',
	},
	{
		headerName: 'PO ID',
		field: 'PO_ID',
	},
	{
		headerName: 'PO ID AP',
		field: 'PO_ID_AP',
	},
	{
		headerName: 'PO TYPE',
		field: 'PO_TYPE',
	},
	{
		headerName: 'PARENT LEGAL ENTITY',
		field: 'PARENT_LEGAL_ENTITY',
	},
	{
		headerName: 'ACCOUNT GROUP',
		field: 'ACCOUNT_GROUP',
	},
	{
		headerName: 'RAW MATERIAL SOURCING REGION',
		field: 'RAW_MATERIAL_SOURCING_REGION',
	},
	{
		headerName: 'VENDOR ID',
		field: 'VENDOR_ID',
	},
	{
		headerName: 'VENDOR NAME',
		field: 'VENDOR_NAME',
	},
	{
		headerName: 'VENDOR COUNTRY',
		field: 'VENDOR_COUNTRY',
	},
	{
		headerName: 'VENDOR ADDRESS',
		field: 'VENDOR_ADDRESS',
	},
	{
		headerName: 'VENDOR ADDRESS CITY',
		field: 'VENDOR_ADDRESS_CITY',
	},
	{
		headerName: 'AP GEO VENDOR REGION',
		field: 'AP_GEO_VENDOR_REGION',
	},
	{
		headerName: 'AP GEO VENDOR COUNTRY',
		field: 'AP_GEO_VENDOR_COUNTRY',
	},
	{
		headerName: 'AP GEO VENDOR COST GROUP',
		field: 'AP_GEO_VENDOR_COST_GROUP',
	},
	{
		headerName: 'HARMONIZED VENDOR ID',
		field: 'HARMONIZED_VENDOR_ID',
	},
	{
		headerName: 'HARMONIZED VENDOR NAME',
		field: 'HARMONIZED_VENDOR_NAME',
	},
	{
		headerName: 'PURCHASING LEGAL ENTITY',
		field: 'PURCHASING_LEGAL_ENTITY',
	},
	{
		headerName: 'PURCHASING DEPARTMENT',
		field: 'PURCHASING_DEPARTMENT',
	},
	{
		headerName: 'PURCHASING LOCATION ID',
		field: 'PURCHASING_LOCATION_ID',
	},
	{
		headerName: 'PURCHASING GROUP',
		field: 'PURCHASING_GROUP',
	},
	{
		headerName: 'PURCHASING COUNTRY',
		field: 'PURCHASING_COUNTRY',
	},
	{
		headerName: 'PURCHASING ADDRESS',
		field: 'PURCHASING_ADDRESS',
	},
	{
		headerName: 'PURCHASING ADDRESS CITY',
		field: 'PURCHASING_ADDRESS_CITY',
	},
	{
		headerName: 'AP GEO PURCHASING ENTITY REGION',
		field: 'AP_GEO_PURCHASING_ENTITY_REGION',
	},
	{
		headerName: 'AP GEO PURCHASING ENTITY COUNTRY',
		field: 'AP_GEO_PURCHASING_ENTITY_COUNTRY',
	},
	{
		headerName: 'AP GEO PURCHASING ENTITY COST GROUP',
		field: 'AP_GEO_PURCHASING_ENTITY_COST_GROUP',
	},
	{
		headerName: 'RECEIVING LEGAL ENTITY',
		field: 'RECEIVING_LEGAL_ENTITY',
	},
	{
		headerName: 'RECEIVING DEPARTMENT',
		field: 'RECEIVING_DEPARTMENT',
	},
	{
		headerName: 'RECEIVING GROUP',
		field: 'RECEIVING_GROUP',
	},
	{
		headerName: 'RECEIVING COUNTRY',
		field: 'RECEIVING_COUNTRY',
	},
	{
		headerName: 'RECEIVING ADDRESS',
		field: 'RECEIVING_ADDRESS',
	},
	{
		headerName: 'RECEIVING ADDRESS CITY',
		field: 'RECEIVING_ADDRESS_CITY',
	},
	{
		headerName: 'AP GEO RECEIVING ENTITY REGION',
		field: 'AP_GEO_RECEIVING_ENTITY_REGION',
	},
	{
		headerName: 'AP GEO RECEIVING ENTITY COUNTRY',
		field: 'AP_GEO_RECEIVING_ENTITY_COUNTRY',
	},
	{
		headerName: 'AP GEO RECEIVING ENTITY COST GROUP',
		field: 'AP_GEO_RECEIVING_ENTITY_COST_GROUP',
	},
	{
		headerName: 'PO BASE CURRENCY',
		field: 'PO_BASE_CURRENCY',
		cellEditor: 'agSelectCellEditor',
		cellEditorParams: {
			values: ['USD', 'EUR', 'GBP'],
		},
	},
	{
		headerName: 'PO BASE SPEND',
		field: 'PO_BASE_SPEND',
	},
	{
		headerName: 'PO LINE ITEM DESCRIPTION',
		field: 'PO_LINE_ITEM_DESCRIPTION',
	},
	{
		headerName: 'PO GL CODE',
		field: 'PO_GL_CODE',
	},
	{
		headerName: 'PO COST CENTRE',
		field: 'PO_COST_CENTRE',
	},
	{
		headerName: 'PO CREATION DATE',
		field: 'PO_CREATION_DATE',
	},
	{
		headerName: 'NET VALUE BASE GBP',
		field: 'NET_VALUE_BASE_GBP',
	},
	{
		headerName: 'NET VALUE BASE EUR',
		field: 'NET_VALUE_BASE_EUR',
	},
	{
		headerName: 'NET VALUE BASE USD',
		field: 'NET_VALUE_BASE_USD',
	},
	{
		headerName: 'SOURCEABLE',
		field: 'SOURCEABLE',
		cellEditor: 'agSelectCellEditor',
		cellEditorParams: {
			values: ['true', 'false'],
		},
	},
	{
		headerName: 'DPO',
		field: 'DPO',
	},
	{
		headerName: 'AP Taxonomy',
		children: [
			{
				headerName: 'AP L1Category',
				field: 'AP_L1Category',
			},
			{
				headerName: 'AP L1Code',
				field: 'AP_L1Code',
			},
			{
				headerName: 'AP L2Category',
				field: 'AP_L2Category',
			},
			{
				headerName: 'AP L2Code',
				field: 'AP_L2Code',
			},
			{
				headerName: 'AP L3Category',
				field: 'AP_L3Category',
			},
			{
				headerName: 'AP L3Code',
				field: 'AP_L3Code',
			},
			{
				headerName: 'AP L4Category',
				field: 'AP_L4Category',
			},
			{
				headerName: 'AP L4Code',
				field: 'AP_L4Code',
			},
			{
				headerName: 'AP L5Category',
				field: 'AP_L5Category',
			},
		],
	},
	{
		headerName: 'Client Taxonomy',
		children: [
			{
				headerName: 'Custom L1Category',
				field: 'Custom_L1Category',
			},
			{
				headerName: 'Custom L1Code',
				field: 'Custom_L1Code',
			},
			{
				headerName: 'Custom L2Category',
				field: 'Custom_L2Category',
			},
			{
				headerName: 'Custom L2Code',
				field: 'Custom_L2Code',
			},
			{
				headerName: 'Custom L3Category',
				field: 'Custom_L3Category',
			},
			{
				headerName: 'Custom L3Code',
				field: 'Custom_L3Code',
			},
			{
				headerName: 'Custom L4Category',
				field: 'Custom_L4Category',
			},
			{
				headerName: 'Custom L4Code',
				field: 'Custom_L4Code',
			},
			{
				headerName: 'Custom L5Category',
				field: 'Custom_L5Category',
			},
			{
				headerName: 'Custom L5Code',
				field: 'Custom_L5Code',
			},
		],
	},
	{
		headerName: 'CLASSIFIED BY',
		field: 'CLASSIFIED_BY',
		cellEditor: 'agSelectCellEditor',
		cellEditorParams: {
			// TODO: add support for select edit type by requesting options
			values: ['model+ web', 'NA', 'rules', 'apvendordb', 'model + web'], // do we need the first item?
		},
	},
	{
		headerName: 'PREDICTION CONFIDENCE',
		field: 'PREDICTION_CONFIDENCE',
	},
	{
		headerName: 'website',
		field: 'website',
	},
	{
		headerName: 'Custom',
		children: customDataColumnNames.map(colName => ({
			headerName: colName,
			field: colName,
		})),
	},
];

export const TYPES = {
	boolean: 'boolean',
	currency: 'currency',
	select: 'select',
	notEditable: 'notEditable',
	numeric: 'numeric',
	taxonomy: 'taxonomy',
	int: '',
	text: '',
};

// controls editing
export const TYPES_CELLS_MAP = {
	OUT_SCOPE: 'boolean',
	SOURCEABLE: 'boolean',
	PO_CURRENCY: 'currency',
	CLASSIFIED_BY: 'select',

	// not editable
	ID: 'notEditable',
	// AP_L1Category: 'notEditable',
	AP_L1Code: 'notEditable',
	// AP_L2Category: 'notEditable',
	AP_L2Code: 'notEditable',
	// AP_L3Category: 'notEditable',
	AP_L3Code: 'notEditable',
	// AP_L4Category: 'notEditable',
	AP_L4Code: 'notEditable',
	AP_L5Category: 'notEditable',
	HARMONIZED_VENDOR_ID: 'notEditable',
	HARMONIZED_VENDOR_NAME: 'notEditable',
	PURCHASING_LOCATION: 'notEditable',
	RECEIVING_LOCATION: 'notEditable',
	IsTailSpend: 'notEditable',
	VENDOR_ID: 'notEditable',
};

export const chartFilterColumns = {
	supplierId: 'VENDOR_ID',
	supplier: 'VENDOR_ID',
	harmonizedSupplierId: 'HARMONIZED_VENDOR_ID',
	harmonizedSupplier: 'HARMONIZED_VENDOR_ID',
	vendorName: 'HARMONIZED_VENDOR_NAME',
	company: 'PARENT_LEGAL_ENTITY',
	companies: 'PARENT_LEGAL_ENTITY',
	spendType: 'SPEND_TYPE',
	purchasingLegalEntity: 'PURCHASING_LEGAL_ENTITY',
	purchasingLocationCountry: 'PURCHASING_LOCATION_COUNTRY',
	purchasingLocationState: 'PURCHASING_LOCATION_STATE',
	receivingLocationCountry: 'RECEIVING_LOCATION_COUNTRY',
	receivingLocationState: 'RECEIVING_LOCATION_STATE',
	costCentre: 'PO_COST_CENTRE',
	monthYearDate: 'PO_CREATION_DATE',
	clientCategoryL1: 'Custom_L1Category',
	clientCategoryL2: 'Custom_L2Category',
	clientCategoryL3: 'Custom_L3Category',
	clientCategoryL4: 'Custom_L4Category',
	categoryL4: 'AP_L4Category',
	isTailSpend: 'IsTailSpend',
	sourceable: 'SOURCEABLE',

	...COLUMNS,
	...customDataColumnsMixin,
};

const customDataFilterMixin = customDataColumnNames.reduce(
	(res, colName) => ({ ...res, [colName]: 'agSetColumnFilter' }),
	{}
);
export const FILTER_TYPES = {
	[COLUMNS.ID]: 'agNumberColumnFilter',
	[COLUMNS.PO_BASE_SPEND]: 'agNumberColumnFilter',
	[COLUMNS.NET_VALUE_BASE_GBP]: 'agNumberColumnFilter',
	[COLUMNS.NET_VALUE_BASE_EUR]: 'agNumberColumnFilter',
	[COLUMNS.NET_VALUE_BASE_USD]: 'agNumberColumnFilter',
	[COLUMNS.AP_L1Code]: 'agNumberColumnFilter',
	[COLUMNS.AP_L2Code]: 'agNumberColumnFilter',
	[COLUMNS.AP_L3Code]: 'agNumberColumnFilter',
	[COLUMNS.AP_L4Code]: 'agNumberColumnFilter',
	[COLUMNS.Custom_L1Code]: 'agNumberColumnFilter',
	[COLUMNS.Custom_L2Code]: 'agNumberColumnFilter',
	[COLUMNS.Custom_L3Code]: 'agNumberColumnFilter',
	[COLUMNS.Custom_L4Code]: 'agNumberColumnFilter',
	[COLUMNS.Custom_L5Code]: 'agNumberColumnFilter',
	[COLUMNS.PREDICTION_CONFIDENCE]: 'agNumberColumnFilter',
	[COLUMNS.DPO]: 'agNumberColumnFilter',
	[COLUMNS.PURCHASING_LOCATION_ID]: 'agNumberColumnFilter',
	[COLUMNS.SOURCEABLE]: 'agSetColumnFilter',
	[COLUMNS.IsTailSpend]: 'agSetColumnFilter',
	[COLUMNS.SPEND_TYPE]: 'agSetColumnFilter',
	[COLUMNS.PARENT_LEGAL_ENTITY]: 'agSetColumnFilter',
	[COLUMNS.PO_CREATION_DATE]: 'agDateColumnFilter',
	[COLUMNS.AP_L1Category]: 'agSetColumnFilter',
	[COLUMNS.AP_L2Category]: 'agSetColumnFilter',
	[COLUMNS.AP_L3Category]: 'agSetColumnFilter',
	[COLUMNS.AP_L4Category]: 'agSetColumnFilter',

	...customDataFilterMixin,
};

export const CONDITIONS_SUFFIX_MAP = {
	equals: '',
	notEqual: 'not',
	notContains: 'not_contains',
	contains: 'contains',
	endsWith: 'ends_with',
	in: 'in',
	inRange: 'in',
	notEndsWith: 'not_ends_with',
	notIn: 'not_in',
	notStartsWith: 'not_starts_with',
	startsWith: 'starts_with',
	greaterThanOrEqual: 'gte',
	greaterThan: 'gt',
	lessThan: 'lt',
	lessThanOrEqual: 'lte',
};
